var FontFaceObserver = require("fontfaceobserver");

export default class FontFace {
  constructor() {
    this.fonts = {
      aonikRegular: new FontFaceObserver("Aeonik"),
      aonikRegularItalic: new FontFaceObserver("Aeonik", {
        weight: 400,
        style: "italic",
      }),
      aonikMedium: new FontFaceObserver("Aeonik", {
        weight: 500,
      }),
      aonikMediumItalic: new FontFaceObserver("Aeonik", {
        weight: 500,
        style: "italic",
      }),
      classicoRegular: new FontFaceObserver("classico-urw"),
      classicoRegularItalic: new FontFaceObserver("classico-urw", {
        weight: 400,
        style: "italic",
      }),
      classicoMedium: new FontFaceObserver("classico-urw", {
        weight: 500,
      }),
      classicoMediumItalic: new FontFaceObserver("classico-urw", {
        weight: 500,
        style: "italic",
      }),
    };

    this.html = document.documentElement;
    this.html.classList.add("fonts-loading");

    if (sessionStorage.fontsLoaded) {
      this.html.classList.add("fonts-loaded");
    }
  }

  init() {
    this.load();
  }

  load() {
    Promise.all([
      this.fonts.aonikRegular.load(),
      this.fonts.aonikRegularItalic.load(),
      this.fonts.aonikMedium.load(),
      this.fonts.aonikMediumItalic.load(),
      this.fonts.classicoRegular.load(),
      this.fonts.classicoRegularItalic.load(),
      this.fonts.classicoMedium.load(),
      this.fonts.classicoMediumItalic.load(),
    ])
      .then(
        function() {
          this.html.classList.remove("fonts-loading");
          this.html.classList.add("fonts-loaded");
          sessionStorage.fontsLoaded = true;
        }.bind(this)
      )
      .catch(
        function() {
          this.html.classList.remove("fonts-loading");
          this.html.classList.add("fonts-failed");
          sessionStorage.fontsLoaded = false;
        }.bind(this)
      );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/fontFace.js